import { render, staticRenderFns } from "./appointmentDelivery.vue?vue&type=template&id=56e28535&scoped=true&"
import script from "./appointmentDelivery.vue?vue&type=script&lang=js&"
export * from "./appointmentDelivery.vue?vue&type=script&lang=js&"
import style0 from "./appointmentDelivery.vue?vue&type=style&index=0&id=56e28535&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e28535",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/workspace/DEPLOY/ibu-owt-core/ibu-owt-core-owt-ssr-nuxt/components/SvgIcon.vue').default})
